module.exports = __webpack_public_path__ + "img/transparent.56ae8d07.gif";